module.exports = __webpack_public_path__ + "static/media/icon_list_selected.cbea79d5.svg";